// extracted by mini-css-extract-plugin
export default {"timePeriod":"TimePeriodSelector_timePeriod__+FZkk","preset":"TimePeriodSelector_preset__mxTjH"};